import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { filter, map, Observable, tap } from 'rxjs';
import { Location } from '@angular/common';
import { PropertyService } from './service/property.service';

@Component({
	selector: 'app-properties',
	templateUrl: './properties.page.html',
	styleUrls: ['./properties.page.scss'],
})
export class PropertiesPage implements OnInit {
	getPropertyList$: Observable<any> = new Observable();
	loaded$: Observable<any> = new Observable();
	courseId: any;
	cohortId: any;
	// properties: any;
	// propertyArray: any = [
	// 	{
	// 		name: 'weeks',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'eventWeightAge',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'modulesWeightAge',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'assignmentWeightAge',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'installments_enabled',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'refundWeeks',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'paymentLink',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'CohortType',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'MentorRequestForm',
	// 		value: [],
	// 	},
	// 	{
	// 		name: 'Color',
	// 		value: [],
	// 	},
	// ];
	// propObj: any;
	constructor(
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,

		private location: Location,
		private propertyService: PropertyService,
	) {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.courseId = locationPath[3];
		this.cohortId = locationPath[6];

		this.propertyService.loadPropertyinit(this.cohortId).subscribe();
		this.propertyService.loadPropertyapi(this.cohortId).subscribe();

		this.propertyService.fetchPropertydata(this.cohortId);

		this.getPropertyList$ = this.propertyService.fetchPropertydata(
			this.cohortId,
		);
		// this.propertyService
		// 	.getPropertyLists(this.courseId)
		// 	.pipe(
		// 		map((data: any) =>
		// 			data.filter((course: any) =>
		// 				course.id == this.cohortId ? course : false,
		// 			),
		// 		),
		// 		tap((data: any) => {
		// 			this.propObj = data[0].properties;
		// 			// console.log(this.propObj, 'lol');
		// 			this.properties = Object.keys(data[0].properties);

		// 			for (let i = 0; i < this.propertyArray.length; i++) {
		// 				// console.log(this.propertyArray[i].name, 'print');
		// 				let prop = this.propertyArray[i].name;
		// 				// let propval = this.propertyArray[i].value;
		// 				// console.log(this.propObj, prop);
		// 				if (this.properties.includes(prop)) {
		// 					// console.log(this.propObj[prop], 'ol');
		// 					this.propertyArray[i].value = this.propObj[prop];
		// 					// console.log(true, prop);
		// 				}
		// 				//  else {
		// 				// 	console.log(false);
		// 				// }
		// 			}
		// 			console.log(this.propertyArray);
		// 		}),
		// 	);
	}

	ngOnInit() {
		// console.log(this.cohortId, 'id here');
	}
	isCanOpenBox = true;
	createFaq() {}

	async editProperty(id: any) {
		console.log(id, 'heres');
		// ev.stopPropagation();
		// if (this.isCanOpenBox) {
		// 	this.isCanOpenBox = false;
		// 	const modal = await this.popoverController.create({
		// 		component: CoursesEditComponent,
		// 		componentProps: {
		// 			courses,
		// 			isUpdate: true,
		// 		},
		// 	});
		// 	modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;
		// 	await modal.present();
		// 	await modal.onDidDismiss();
		// 	this.isCanOpenBox = true;
		// }
	}

	deleteProperty(id: any) {}
}
